import { getAuth, createUserWithEmailAndPassword } from "firebase/auth";
import Form from "react-bootstrap/Form";
import { useState } from "react";
import Button from "react-bootstrap/Button";
import Spinner from "react-bootstrap/Spinner";
import FloatingLabel from "react-bootstrap/FloatingLabel";
import { FirebaseError } from "firebase/app";
import firebaseErrors from "../../modules/firebaseErrors";
import { Link } from "react-router-dom";

const auth = getAuth();

export default function Register() {
	const [authenticating, setAuthenticating] = useState(false);

	const [noticeAccepted, setNoticeAccepted] = useState(false);

	const [email, setEmail] = useState("");
	const [password, setPassword] = useState("");

	const [error, setError] = useState<string>();

	return (
		<div>
			<FloatingLabel label="Email-Adresse" className="mb-2">
				<Form.Control
					type="email"
					placeholder=""
					value={email}
					onChange={(e) => setEmail(e.target.value)}
				/>
			</FloatingLabel>
			<FloatingLabel label="Passwort" className="mb-2">
				<Form.Control
					type="password"
					placeholder=""
					value={password}
					onChange={(e) => setPassword(e.target.value)}
				/>
			</FloatingLabel>

			<Form.Check
				type="checkbox"
				checked={noticeAccepted}
				onChange={(e) => setNoticeAccepted(e.target.checked)}
				label={
					<div>
						Ich habe die <Link to="/privacy">Datenschutzerklärung</Link> zur Kenntnis genommen.
					</div>
				}
				className="mb-2"
			/>

			{error && <div className="mb-2 text-danger">{error}</div>}

			<Button
				variant="success"
				className="mb-2"
				disabled={authenticating}
				onClick={async () => {
					if (!noticeAccepted) {
						setError(
							"Bitte bestätige, dass du die Datenschutzerklärung zur Kenntnis genommen hast.",
						);
						return;
					}

					setAuthenticating(true);
					setError(undefined);

					try {
						await createUserWithEmailAndPassword(auth, email, password);
					} catch (error) {
						if (error instanceof FirebaseError) {
							setAuthenticating(false);

							const message = firebaseErrors[error.code] ?? error.message;

							setError(message);
							return;
						}

						throw error;
					}
				}}>
				{authenticating && <Spinner className="me-1" animation="border" size="sm" />}
				Registrieren
			</Button>
		</div>
	);
}
